<template>
    <div  style="height:inherit" class="leftclass">
          <div class="menu-list">
            <div class="rowlist flex  alighn-cen" 
            v-for="(item,index) in treedata" 
            :key = "item.id"
            :class="{current:active==index && !item.children}"  
            @click='openchilden(index,item.name,item.children)'
            >
            <div v-if="!item.children" class="inls"
            >
              <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </div>
              <div v-if="item.children" style="width:100%">
                 <el-collapse v-model="activeNames" accordion>
                   <div class="">
                     <el-collapse-item  :name="item.id">
                      <template slot="title">
                      <div class="flex align-cen">
                         <i :class="item.icon"></i>
                        {{item.title}}
                      </div>
                     </template>
                     <div class="childItem-item" 
                      v-for="childItem in item.children" 
                     :key="childItem.id"
                     :index="childItem.name"
                      
                      @click.stop="openViews(childItem.name,childItem.title)"
                     >
                     <div  :class="{chcurrent:chative == childItem.name}">
                      {{childItem.title}}
                     </div>
                      
                     </div>
                     </el-collapse-item>
                   </div>
                 </el-collapse>
              </div>
            </div>
            <!-- <div class="rowlist" v-for="(item,index) in treedata" :key = "item.id"
            :class="{current:active==index}"
            @click='openchilden(index,item.name,item.children)'
            >
               <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </div>
               <div class="cosspan">
                <div v-for="(item,index) in treedata" :key = "item.name">
                <el-collapse v-model="activeNames" v-if="active == index">
                  <div class="" v-for="(childItem,childIndex) in item.children" :key="childItem.id">
                  <el-collapse-item  :name="childItem.id" v-if="childItem.children">
                     <template slot="title">
                      <div>
                        {{childItem.title}}
                      </div>
                     </template>
                     <div class="childItem-item"  
                     v-for="childItemC in childItem.children" 
                      :key='childItemC.id'
                      :index="childItemC.name"
                      @click="openViews(childItemC.name,childItemC.title)"
                      :class="{chcurrent:chative == childItemC.name}"
                      >
                       {{childItemC.title}}
                      </div>
                  </el-collapse-item>
                  <div v-else class="elsetit" :class="{chcurrent:chative == childItem.name}"
                  @click="openViews(childItem.name,childItem.tile)"
                  >
                     {{childItem.title}}
                  </div>
                    </div>
                </el-collapse>
                </div>
              </div> -->
          </div>
    </div>
</template>
<script>
import LocaStorage from "../../utils/localstorage.js"
export default {
     computed: {
     opened() {
                return this.treedata[this.active].children.map((i) => {
                    return i.id;
                });
            }
},
	data(){
		return {
        businessInfo:{},
        activeNames:['3'],
        chative:'',
        active:'',
        titname:'',
        treedata: [
                    {
                icon:'icon-al-applicationgroup',
                name:'/webenterpriseManage/index',
                path:'',
                title:'应用中心',
                id:'1', 
            },{
                icon:'icon-al-shoppingcart',
                name:'/webenterpriseManage/Order',
                path:'',
                title:'我的订单',
                id:'2', 
            },{
                icon:'icon-al-userplus-fill',
                name:'/webenterpriseManage/teamSet',
                path:'',
                title:'我的团队',
                id:'3', 
                children:[{
                    icon:'',
                    name:'/webenterpriseManage/teamSet',
                    path:'',
                    title:'团队设置',
                    id:'30', 
                    parentId:'3',
                 },
                 {
                    icon:'',
                    name:'/webenterpriseManage/teamAdmin',
                    path:'',
                    title:'成员管理',
                    id:'31', 
                    parentId:'3',
                 },{
                   icon:'',
                    name:'/webenterpriseManage/appSet',
                    path:'',
                    title:'应用权限设置',
                    id:'32', 
                    parentId:'3',
                 },
                 {
                   icon:'',
                    name:'/webenterpriseManage/courseSet',
                    path:'',
                    title:'课程权限设置',
                    id:'33', 
                    parentId:'3',
                 }
                 ]
            },
        ],
		}
	},
  created(){
    this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
    let that = this
    this.chative = this.$route.meta.parent.isShow ? this.$route.meta.parent.path : this.$route.path
    this.active = this.$route.meta.index
  //   this.$bus.$emit("titname",this.titname);
  },
  methods: {
    handleChange(val){
    },
    openchilden(i,url,child){
      this.$router.push(url)
      this.active = i
     this.chative = url
    },
    // 打开页面
    openViews(url,child){
      this.active = -1
      this.chative = url
      this.$router.push(url)
    },
  }
}
</script>
<style scoped lang="scss">
.leftclass{
      overflow-x: hidden;
    overflow-y: auto;
}
 /*滚动条样式*/
        .leftclass::-webkit-scrollbar {
            width: 4px;    
        }
        .leftclass::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            background: rgba(0,0,0,0.2);
        }
        .leftclass::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
            border-radius: 0;
            background: rgba(255,255,255,0.1);

        }
.sider-logo{
  width: 80%;
  margin: 40px auto;
  display: block;
}
.menu-list{
  margin-top: 16px;
}
.rowlist{
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  padding-left: 32px;
  i{
    padding-right: 20px;
    font-size: 18px;
  }
  .inls{
      height: 50px;
  line-height: 50px;
  }
  
}
  .current{
    background: #eff6ff;
    color: #247af3;
    position: relative;
  }
      .chcurrent{
    background: #eff6ff;
    color: #247af3;
    position: relative;
    }
   .current::before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background-color: #2893f1;
    border-radius: 0 4px 4px 0;
   };
   .chcurrent::before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    background-color: #2893f1;
    border-radius: 0 4px 4px 0;
   };
  .cosspan{
    position: fixed;
    left: 120px;
    width: 120px;
    top: 57px;
    height: calc(100vh - 60px);
    border-right: 1px solid #ebedf0;
    z-index: 999;
    overflow-x: hidden;
    overflow-y: auto;
    // box-shadow:0px 0px 3px rgba(0,0,0,.2);
    .cosspan-tit{
      width: 120px;
      height: 56px;
      color: #000;
       border-bottom: 1px solid #ebedf0;
       text-align: center;
       line-height: 56px;
    }
  }
      /*滚动条样式*/
        .cosspan::-webkit-scrollbar {
            width: 4px;    
        }
        .cosspan::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        .cosspan::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);

        }
el-menu {
    background: none !important;
    border: none !important;

}
.el-menu--collapse{
    width: 54px;
}
.el-menu-item.is-active{
        color: #409EFF !important;
}
::v-deep{
   .el-menu-item-group__title{
    padding: 0 !important;
   }
.el-menu--vertical{
     
    color: #FFF;
}
.el-collapse{
  border: none;
      cursor: pointer;
          .el-collapse-item__header{
        color: #666 !important;
        font-size: 14px;
           height: 50px;
           line-height: 50px;
           border-bottom: none;
           font-weight: 400;
         div{
            color: #666 !important;
         }
      }
      .childItem-item,.elsetit{
         height: 50px;
           line-height: 50px;
           font-size: 14px;
           color: #666;
           text-align: center;
      }
      
      .el-collapse-item__content{
        color: #666 !important;
        font-size: 14px;
        padding-bottom: 0;
      }
      .el-collapse-item__arrow{
        margin: inherit;
    margin-left: 30px;
    font-size: 12px;
      }
  .el-collapse-item__wrap{
    border: none;
    margin-left: -32px;
  }
}
}
</style>  